import { render, staticRenderFns } from "./SkillUsers.vue?vue&type=template&id=e45742da&"
import script from "./SkillUsers.vue?vue&type=script&lang=js&"
export * from "./SkillUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports